/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Finding creation request
 * @export
 * @interface FindingCreateRequest
 */
export interface FindingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof FindingCreateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingCreateRequest
     */
    assessmentStatus?: string;
}

/**
 * Check if a given object implements the FindingCreateRequest interface.
 */
export function instanceOfFindingCreateRequest(value: object): value is FindingCreateRequest {
    return true;
}

export function FindingCreateRequestFromJSON(json: any): FindingCreateRequest {
    return FindingCreateRequestFromJSONTyped(json, false);
}

export function FindingCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'assessmentStatus': json['assessmentStatus'] == null ? undefined : json['assessmentStatus'],
    };
}

export function FindingCreateRequestToJSON(json: any): FindingCreateRequest {
    return FindingCreateRequestToJSONTyped(json, false);
}

export function FindingCreateRequestToJSONTyped(value?: FindingCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'assessmentStatus': value['assessmentStatus'],
    };
}

